<div class="manage-staff-container">
<!-- Header Section -->
<div class="manage-staff-header">
  <h1>Manage Staff</h1>
</div>

<!-- Search and Filter Section -->
<div class="search-section">
  <mat-form-field appearance="outline" class="search-field">
    <mat-label>Search Staff</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Search by name, email or phone" #input>
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>
</div>

<!-- Loading Spinner -->
<div class="loading-shade" *ngIf="isLoading">
  <div class="loading-content">
    <mat-spinner diameter="48"></mat-spinner>
    <div class="loading-text">
      <span>Loading staff information</span>
      <span class="loading-dots">...</span>
    </div>
  </div>
</div>

<!-- Table Section -->
<div [ngClass]="{ 'common-height-auto': staffDataSource.data.length === 0 }" class="mat-elevation-z8">
  <table mat-table [dataSource]="staffDataSource" matSort class="table table-striped" [class.loading]="isLoading">

    <!-- Serial Number -->
    <ng-container matColumnDef="serialNo">
      <th mat-header-cell *matHeaderCellDef>#</th>
      <td mat-cell *matCellDef="let element; let i = index">
        {{ paginator.pageIndex * paginator.pageSize + i + 1 }}
      </td>
    </ng-container>

    <!-- Name -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let element">{{ element.Name }} {{ element.LastName }}</td>
    </ng-container>

    <!-- Email -->
    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef>Email</th>
      <td mat-cell *matCellDef="let element">{{ element.Email_Id }}</td>
    </ng-container>

    <!-- Phone -->
    <ng-container matColumnDef="phone">
      <th mat-header-cell *matHeaderCellDef>Phone</th>
      <td mat-cell *matCellDef="let element">{{ element.PhoneNumber }}</td>
    </ng-container>

    <!-- Role -->
    <ng-container matColumnDef="role">
      <th mat-header-cell *matHeaderCellDef>Role</th>
      <td mat-cell *matCellDef="let element">{{ element.Role || 'N/A' }}</td>
    </ng-container>

    <!-- Action -->
    <!-- <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>Action</th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button color="primary" (click)="editStaff(element)">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button color="warn" (click)="deleteStaff(element.ID)">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container> -->

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[5, 10, 25]" [pageSize]="10" showFirstLastButtons aria-label="Staff Paginator">
  </mat-paginator>

  <div *ngIf="staffDataSource.data.length === 0 && !isLoading" class="data-not-found">
    <mat-icon>search_off</mat-icon>
    <p>No staff data found</p>
  </div>
</div>
</div>